import React, { Component } from "react";
import axios from "axios";
import "../style/SignIn.css";
import emailValidation from "../services/emailValidation";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import keys from "../config";
import * as actions from "../actions";

class SignIn extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      submitError: "",
      loading: false
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  async handleSubmit(event) {
    event.preventDefault();
    this.setState({
      loading: true
    });
    const { email, password } = this.state;
    const validEmail = emailValidation(email);
    if (!validEmail) {
      return this.setState({
        submitError: "Please enter a valid email",
        loading: false
      });
    }
    const url = keys.signInUrl;
    const reqBody = {
      email,
      password
    };
    try {
      const res = await axios.post(url, reqBody);
      localStorage.setItem("token", res.data.jwt);
      this.setState({ email: "", password: "" });
      this.props.auth();
    } catch (error) {
      this.setState({
        submitError: "Hmmm, that email/password combination didn't work",
        loading: false
      });
      console.error(error);
    }
  }
  render() {
    const { loading } = this.state;
    return (
      <div>
        <h1 className="form-message">Sign in for access to complete scores</h1>
        {this.state.submitError && <p>{this.state.submitError}</p>}
        <form onSubmit={this.handleSubmit}>
          <div className="input-holder">
            <label className={this.state.email ? "helper-active" : "helper"}>
              Email
            </label>
            <input
              className="sign-input"
              onChange={e => this.setState({ email: e.target.value })}
              value={this.state.email}
              name="email"
              type="email"
              placeholder="Email"
            />
          </div>
          <div className="input-holder">
            <label className={this.state.password ? "helper-active" : "helper"}>
              Password
            </label>
            <input
              className="sign-input"
              onChange={e => this.setState({ password: e.target.value })}
              value={this.state.password}
              name="password"
              type="password"
              placeholder="Password"
            />
          </div>
          <div className="password-reset-container">
            <Link to="/forgot-password">Forgot password?</Link>
          </div>
          {!loading && (
            <div className="submit-btn">
              <button className="btn" type="submit">
                Submit
              </button>
            </div>
          )}
          {loading && (
            <div>
              <div className="spinner-holder">
                <div className="circle">
                  <div className="sub-circle" />
                </div>
              </div>
            </div>
          )}
        </form>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    authenticated: state.authenticated
  };
};

export default connect(
  mapStateToProps,
  actions
)(SignIn);



// WEBPACK FOOTER //
// ./src/components/SignIn.js